// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__h-cwc","label":"Category_label__3vlJW","content":"Category_content__3UDk-","header":"Category_header__2mHyJ","location":"Category_location__22VQN"};